import React from "react";
import { withRouter, Route, Switch, Link } from "react-router-dom";

import Home from "./components/Home";
import AcquisitionCriteria from "./components/AcquisitionCriteria";
import PropertyPortfolio from "./components/PropertyPortfolio";
import Team from "./components/Team";
import Contact from "./components/Contact";

class Routes extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <main>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/team" component={Team} />
          <Route path="/acquisition-criteria" component={AcquisitionCriteria} />
          <Route path="/property-portfolio" component={PropertyPortfolio} />
          <Route path="/contact" component={Contact} />
          <Route
            path="/investor-login"
            component={() => {
              window.location.href =
                "https://growthpropertygroup.investorcafe.app";
              return null;
            }}
          />
        </Switch>
      </main>
    );
  }
}

export default withRouter(Routes);
